
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import MIcon from "@/components/MIcon.vue";
import { Options, Vue } from "vue-class-component";
import { getAuthorityMap } from "@/utils/tutor";

@Options({
  components: {
    MBaseModal,
    MButton,
    MIcon
  },
  props: {
    isOwner: {
      type: Boolean,
      default: false
    },
    isSchool: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close", "clickFileInputRef", "exportAllStaffs"]
})
export default class MsCsvUpdateModal extends Vue {
  isOwner!: boolean;
  isSchool!: boolean;

  get ownerLabel(): string {
    return getAuthorityMap({ isSchool: this.isSchool }).owner;
  }

  get adminLabel(): string {
    return getAuthorityMap({ isSchool: this.isSchool }).admin;
  }

  startUpdating() {
    this.$emit("clickFileInputRef");
  }

  exportStaffs() {
    this.$emit("exportAllStaffs");
  }

  close() {
    this.$emit("close");
  }
}
